import React from "react";
import styles from "./pdf.module.css";
import ResultCard from "../SIPCalculatorResult";
const formatIN = (value) => {
    if (value === null || value === undefined || Number.isNaN(Number(value))) return "-";
    return Number(value).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
 };

const SIPReport = (props) => { 
  const { form,resultCard } = props;  
  return (
    <div>
      {/* Header */}
      <div className={styles.pdf_child_container}>
        <div className={styles.pdf_card}   style={form.annualStepUp ? { paddingBottom: "1rem" } : { paddingBottom: "5rem"}} >
        <h2 className={styles.pdf_title}>SIP Calculator Report</h2> 
        {/* Investment Parameters */}
        <div className={styles.pdf_section}>INPUT DETAILS</div>

        <table className={styles.pdf_input_table}>
          <tr>
            <th>
             Particulars
            </th>
            <th>
              Details
            </th>
          </tr>
          {
            form.annualStepUp && (
             <>
            <tr>
              <td>
               Annual Step Up
              </td>
              <td>
                {form.stepUpType==='percentage'?form.annualStepUp+'%':   '₹' +formatIN(form.annualStepUp)} 
              </td>
            </tr>
            <tr></tr>
             </>
            )
          }

          <tr>
            <td>
              Present Age
            </td>
            <td>
              {form.presentAge} years
            </td>
          </tr>
          <tr>
            <td>
             Target Age
            </td>
            <td>
              {form.targetAge} years
            </td>
          </tr>
          <tr>
            <td>
             Per Month Investment (Outflow)
            </td>
            <td>
             ₹ {formatIN(form.monthlyInvestment)}
            </td>
          </tr>
           <tr>
            <td>
            Expected CAGR (Annualized Return %)
            </td>
            <td>
              { form.cagr}%
            </td>
          </tr>
        </table>
        <div className={styles.pdf_result_header}>
        <div className={styles.pdf_section}>SUMMARY</div>
        <div className={styles.pdf_section_light}>
          Generated on {new Date().toLocaleDateString()}
        </div>
        </div>
        <ResultCard result={resultCard.result}  stepUpResult={resultCard.stepUpResult} />
        <p className={styles.pdf_declaration}>* The above values are estimated based on the assumed rate of return and may vary with market conditions.</p>
        </div>
      </div>
    </div>
  );
};

export default SIPReport;